import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import ErrorBoundary from "MODULES/shared/components/ErrorBoundary";
import { WAREHOUSE } from "MODULES/users/constants";
import Forbidden from "MODULES/shared/components/Authorized/Forbidden";
import LineItemsTable from "./LineItemsTable";

function RepairQuotes({
  location,
  openForm,
  setActiveRepairQuote,
  showNewButton
}) {
  return (
    <div>
      <h2>
        <Link to={`${location.pathname}/repair-quote-line-items`}>
          Repair Quotes <i className="text-muted fa fa-fw fa-list-ol" />
        </Link>
        <Forbidden roles={[WAREHOUSE]}>
          {showNewButton && (
            <button
              onClick={openForm}
              className="btn btn-primary btn-hollow pull-right"
              type="button"
            >
              <i className={`fa fa-fw fa-plus`} />
              Create Quote
            </button>
          )}
        </Forbidden>
      </h2>
      <ErrorBoundary>
        <LineItemsTable setActiveRepairQuote={setActiveRepairQuote} />
      </ErrorBoundary>
    </div>
  );
}

RepairQuotes.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  openForm: PropTypes.func.isRequired,
  setActiveRepairQuote: PropTypes.func.isRequired,
  showNewButton: PropTypes.bool
};

export default withRouter(RepairQuotes);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/RepairQuotes.jsx